<template>
  <div class="filter-input">
    <input
      class="form__input"
      v-on:input="filterArr($event)"
      type="text"
      :placeholder="title"
      v-input-trim>
  </div>
</template>

<script>
  export default {
    name: 'FilterInput',
    props: ['title', 'filterList', 'filterByKey', 'isTree'],
    methods: {
      filterArr: function (e) {
        const _this = this
        let resolveFunc = function (path, obj = self, separator = '.') {
          var properties = Array.isArray(path) ? path : path.split(separator)
          return properties.reduce((prev, curr) => prev && prev[curr], obj)
        }
        let filterFunction = function (item) {
          if (_this.filterByKey) {
            let matchCount = 0
            _this.filterByKey.forEach(key => {
              var field = resolveFunc(key, item) // item[key]
              if (field && field.toLowerCase().includes(filterText)) {
                matchCount++
              }
            })
            return matchCount > 0
          } else {
            return item.toLowerCase().includes(filterText)
          }
        }
        let treeFilter = function (data) {
          return data.filter(item => {
            if (item.childrenCopy) {
              item.children = item.childrenCopy
            }
            if (item.children && item.children.length > 0) {
              item.childrenCopy = item.children
              item.children = treeFilter(item.children)
            }
            return item.children.length > 0 || filterFunction(item)
          })
        }
        let filterText = e.target.value.toLowerCase()
        let filteredArr = [...this.filterList]
        if (this.isTree !== true) {
          filteredArr = filteredArr.filter(item => {
            return filterFunction(item)
          })
        } else {
          filteredArr = treeFilter(filteredArr)
        }
        this.$emit('filter', filteredArr)
      }
    }
  }
</script>
